import {
    SelectMarketPage,
    SelectAppointmentDetailsPage,
    SelectAppointmentPage,
    PatientInformationPage,
    ReviewDetailsPage,
    BookingConfirmationPage,
} from 'pages';
import { Route, Routes } from 'react-router';

const AppRoutes = () => {
    return (
        <Routes>
            <Route index element={<SelectMarketPage />} />
            <Route path="/select-appointment-details" element={<SelectAppointmentDetailsPage />} />
            <Route path="/select-appointment" element={<SelectAppointmentPage />} />
            <Route path="/patient-information" element={<PatientInformationPage />} />
            <Route path="/review-details" element={<ReviewDetailsPage />} />
            <Route path="/confirmation" element={<BookingConfirmationPage />} />
        </Routes>
    );
};

export { AppRoutes };
